export const PencilIcon: React.FC = () => (
  <svg
    width="13"
    height="13"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.9"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M14.5 4.5l5 5" />
    <path d="M4 20l1-4L16 5l3 3L8 19z" />
  </svg>
);
